<template>
  <div>
    <h3>{{ $t('notification') }}</h3>
    <b-card>
      <b-form class="">
        <br>
        <b-row style="gap: 1rem;">
          <b-col
            cols="12"
            mb="4"
          >
            <b-form-checkbox
              id="accountSwitch1"
              v-model="notification.ticket.status"
              checked="checked"
              name="check-button"
              switch
              inline
            >
              <span>{{ $t('profile_notification_ticket') }}</span>
            </b-form-checkbox>
          </b-col>
          <b-col
            cols="12"
            mb="4"
          >
            <b-form-checkbox
              id="accountSwitch2"
              v-model="notification.announcements.status"
              checked="checked"
              name="check-button"
              switch
              inline
            >
              <span>{{ $t('profile_notification_announcements') }}</span>
            </b-form-checkbox>
          </b-col>
          <b-col
            cols="12"
            mb="4"
          >
            <b-form-checkbox
              id="accountSwitch3"
              v-model="notification.login.status"
              name="check-button"
              switch
              inline
            >
              <span>{{ $t('profile_notification_login') }}</span>
            </b-form-checkbox>
          </b-col>
          <!--/ application switch -->
          <!-- buttons -->
          <b-col
            cols="12"
            class="d-flex justify-content-end"
          >
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-1 mt-1"

              @click="submit"
            >
              <span v-if="!pending"> {{ $t('save_changes') }}</span>
              <b-spinner
                v-else
                small
                type="grow"
              />
            </b-button>
          </b-col>
          <!--/ buttons -->
        </b-row>
      </b-form>
    </b-card>
  </div>
</template>
<script>

import Notification from '@/views/logics/profile/Notification'

export default {
  mixins: [Notification],
}
</script>
